// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/EventSummaryModal/styles.css
// module id = 398
// module chunks = 0